import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IconHover, ModeOptionType } from '../../../../shared/enum/common-enum';
// import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-barcode-scanner-modal',
  templateUrl: './barcode-scanner-modal.component.html',
  styleUrls: ['./barcode-scanner-modal.component.scss'],
})
export class BarcodeScannerModalComponent implements AfterViewInit{
@ViewChild('barcodeTextarea') barcodeTextarea!: ElementRef;
currentHoverEffect = IconHover.Pink;
slideData=['uploadAllData','inventoryData','dataDelete']
barcodeData:any;
barcodeCount: any;
@Input() data : any;
modeOptiontype = ModeOptionType;
constructor(public activeModal: NgbActiveModal){ }

  ngAfterViewInit(): void {
    this.barcodeTextarea?.nativeElement?.focus();
  }
// carousal methods
  owlcarousel14Options = {
    items: 1,
    margin: 10,
    autoHeight: true,
    nav: false,
    loop: true,
  }

  onClick() {
    const { normalMode, inventoryMode } = this?.data || {};
    const { NormalMode, InventoryMode } = this?.modeOptiontype || {};
  
    if (normalMode === NormalMode) {
      this?.activeModal?.close();
      return;
    }
  
    if (inventoryMode === InventoryMode && this?.barcodeData) {
      const barcodeList = this?.barcodeData
        ?.split('\n')
        .map(barcode => barcode.trim())
        .filter(Boolean);
  
      const uniqueBarcodes = Array.from(new Set(barcodeList));
      this?.activeModal?.close(uniqueBarcodes);
    }
  }
  

  totalCount(){
     this.barcodeCount = this?.barcodeData?.split('\n').filter(barcode => barcode?.trim());;
  }
  
  onSlideChange() {
    this.barcodeTextarea?.nativeElement?.focus();
  }

}
